export default {
  SET_CALL_ALERT_CONFIGURATION(state, data = {}) {
    state.callAlertConfig.humanMaxDuration = parseInt(data.max_call_time || 0, 10);
    state.callAlertConfig.timeShowAlertFromMax = parseInt(data.show_alert || 60, 10);
    if (data.text) {
      state.callAlertConfig.textOnAlert = data.text;
    }
  },
  SET_CURRENT_STATUS_START_TIME(state, currentStatusStartTime) {
    state.currentStatusStartTime = currentStatusStartTime;
  },
  SET_STATUS_MANUAL_CALL(state, currentStatus) {
    state.isOnManualCall = currentStatus;
  },
  SET_SOUND_ALERT(state, sound) {
    state.sound = sound;
  },
  SET_LAST_CALL_EXCEEDED(state, callId) {
    state.lastCallExceeded = callId;
  },
};



// WEBPACK FOOTER //
// ./src/store/call_time_and_alert/mutations.js